import * as React from 'react';

import PostCard from 'bundles/tutorials/components/PostCard';
import type { Asset, Maybe, Scalars } from 'bundles/unified-seo-content-common/__generated__/baseContentfulTypes';

type Props = {
  featuredImage?: Maybe<Pick<Asset, 'title' | 'description' | 'width' | 'height' | 'url'>>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  intro?: Maybe<Scalars['String']>;
  sys?: Maybe<{ firstPublishedAt?: Maybe<Scalars['DateTime']> }>;
};

const TutorialHubCard = ({ title, featuredImage, slug, intro, sys }: Props) => {
  if (!title || !slug) {
    return null;
  }

  return (
    <PostCard
      title={title || 'Coursera Tutorials'}
      cardImage={featuredImage}
      href={`/tutorials/${slug}`}
      description={intro || 'This is a Coursera Tutorial'}
      publishedDate={sys?.firstPublishedAt}
      dataE2EAttribute="tutorial-hub-card"
    />
  );
};

export default TutorialHubCard;
